import React from "react";
import { PageHeader, Button, Icon, Col, Row } from "antd";

export default function Header(props) {
  return (
    <PageHeader
      title={
        <div>
          <Icon type="container" />
          &nbsp;&nbsp;<span>{props.title}</span>
        </div>
      }
    extra={
      <Row gutter={[10, 16]} style={{ width: '100%' }}>
        {props.onNew && (
          <Col xs={12} sm={12} md={6} lg={6}>
            <Button
              icon="plus"
              type="primary"
              loading={props.loadingNew}
              onClick={props.onNew}
              block
            >
              Nuevo
            </Button>
          </Col>
        )}
        {props.onNewCargaMasiva && (
          <Col xs={12} sm={12} md={6} lg={6}>
            <Button
              icon="upload"
              type="primary"
              loading={props.loadingNewCargaMasiva}
              onClick={props.onNewCargaMasiva}
              block
            >
              Carga 
            </Button>
          </Col>
        )}
        {props.onSearch && (
          <Col xs={12} sm={12} md={6} lg={6}>
            <Button
              icon="search"
              type="primary"
              loading={props.loadingSearch}
              ghost
              onClick={props.onSearch}
              block
            >
              Buscar
            </Button>
          </Col>
        )}
        {props.onClearFilters && (
          <Col xs={12} sm={12} md={6} lg={6}>
            <Button
              icon="shake"
              type="primary"
              loading={props.loadingSearch}
              ghost
              onClick={props.onClearFilters}
              block
            >
              Limpiar
            </Button>
          </Col>
        )}
      </Row>
    }
    ></PageHeader>
  );
}
